import { useQuery } from "@tanstack/react-query";
import { priorityService } from "@/services/priorityService";
import { PriorityStatus } from "@/types";

const PRIORITY_LIMIT = 50;
const MY_ONETHING_STATUSES: PriorityStatus[] = ["focus", "queue", "on-hold", "waiting", "blocked"];

/**
 * Shared query for the current user's My OneThing priorities (focus, queue,
 * on-hold, waiting, blocked). Keep the `["my-onething", "priorities", userPid]`
 * key stable — other mutations invalidate via the `["my-onething"]` prefix.
 */
export function useMyPriorities(userPid?: string) {
  return useQuery({
    queryKey: ["my-onething", "priorities", userPid],
    queryFn: () =>
      priorityService.getPriorities({
        userPid,
        statuses: MY_ONETHING_STATUSES,
        // Candidates never rank, so they stay out of the personal focus/queue.
        candidate: false,
        page: 1,
        limit: PRIORITY_LIMIT,
      }),
    enabled: Boolean(userPid),
  });
}
